const url = window.location.href;
const resourcePath = url.substring(0, url.lastIndexOf('/'));

function setSession(name, value, ttl = 86400000) { // ttl is in milliseconds
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(name, JSON.stringify(item));
}

function getSession(name) {
  const itemStr = localStorage.getItem(name);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(name);
    return null;
  }
  return item.value;
}

function checkLoggedIn() {
  const userLoggedIn = getSession("loggedInPotree");
  return userLoggedIn === "true";
}

async function fetchPasswords() {
  try {
    const response = await fetch(`${resourcePath}/data.json`);
    if (!response.ok) {
      throw new Error('Fehler beim Login');
    }
    return await response.json();
  } catch (error) {
    const fallbackUrl = window.location.href.replace('.html', '.json');
    const fallbackResponse = await fetch(fallbackUrl);
    if (!fallbackResponse.ok) {
      throw new Error('Fehler beim hashed password fetchen');
    }
    const fallbackData = await fallbackResponse.json();
    const passwordPath = fallbackData.passwordPath;
    const passwordResponse = await fetch(passwordPath);
    if (!passwordResponse.ok) {
      throw new Error('Login fallback fehlgeschlagen');
    }
    return await passwordResponse.json();
  }
}

async function login() {
  if (checkLoggedIn()) {
    return;
  }
  const storedBase64Passwords = await fetchPasswords();
  if (!storedBase64Passwords) {
    return;
  }
  const userPassword = prompt("Bitte geben Sie Ihr Passwort ein:");
  const encodedUserPassword = btoa(userPassword);

  if (!storedBase64Passwords.data.includes(encodedUserPassword)) {
    alert("Passwort ist falsch!");
    location.reload();
  } else {
    setSession("loggedInPotree", "true"); // Set session with 10 seconds TTL
  }
}

export default login;